/**
 * @file 路由
 * @author rentingting@baidu.com
 */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/main',
        beforeEnter: () => {
            window.location = './main.html';
        }
    }
];

const router = new Router({
    routes
});
router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    next();
});

export {
    router
};
